import React from 'react';
import { Card, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { CardContent } from '@sierralabs/react-material-ui';
const StyledCard = styled(Card) `
  form {
    /* padding: 0 32px; */
  }
  .inline-description {
    margin-bottom: 30px;
  }
  .card-title {
    margin-bottom: 20px;
  }
`;
export const InlineFormCard = props => {
    const { label, description, children } = props;
    return (React.createElement(StyledCard, { className: 'survey-form-card' },
        React.createElement(CardContent, { padding: 'large' },
            label && (React.createElement(Typography, { variant: 'h3', gutterBottom: true, className: 'inline-title' }, label)),
            description && (React.createElement(Typography, { variant: 'subtitle2', className: 'inline-description' }, description)),
            children)));
};
const StyledActionsDiv = styled.div `
  display: flex;
  margin-top: 20px;
  width: 100%;
  button,
  a {
    margin-right: 20px;
    :last-child {
      margin-right: 0;
    }
  }
`;
export const InlineActions = props => {
    const { children } = props;
    return (React.createElement(StyledActionsDiv, { className: 'inline-actions' }, children));
};
export default InlineFormCard;
//# sourceMappingURL=InlineFormCard.js.map